import Vue from 'vue'
import App from './App.vue'
import BaiduMap from 'vue-baidu-map'
import 'element-ui/lib/theme-chalk/index.css';
import router from './router/router'
import store from './store/store'
import {
  Button,
  ButtonGroup,
  Message,
  Loading,
  Alert,
  Menu,
  Rate,
  Image,
  Form,
  FormItem,
  Select,
  Option,
  OptionGroup,
  DatePicker,
  Switch,
  Col,
  Upload,
  Dropdown,
  Table,
  TableColumn,
  Pagination,
  DropdownMenu,
  DropdownItem,
  Tag,
  Submenu,
  Input,
  InputNumber,
  MenuItem,
  MessageBox,
  Tooltip,
  Dialog,
  Tabs,
  TabPane,
  MenuItemGroup,
  TimePicker,
  Checkbox,
  CheckboxButton,
  CheckboxGroup,
  Radio,
  RadioGroup,
  RadioButton,
} from 'element-ui';
import lang from 'element-ui/lib/locale/lang/en'
import locale from 'element-ui/lib/locale'
import {showLoading, hideLoading} from '@/utils/util'

Vue.use(BaiduMap, {
  ak: 'SypSLYR2GooWjMdpicc3Kw0mqgHX5qOZ'
});

locale.use(lang);

Vue.use(Button);
Vue.use(Pagination);
Vue.use(Alert);
Vue.use(Loading.directive);
Vue.use(Menu);
Vue.use(Rate);
Vue.use(Dialog);
Vue.use(Dropdown);
Vue.use(TimePicker);
Vue.use(Tabs);
Vue.use(TabPane);
Vue.use(DropdownMenu);
Vue.use(DropdownItem);
Vue.use(Submenu);
Vue.use(Tooltip);
Vue.use(Image);
Vue.use(Table);
Vue.use(Form);
Vue.use(FormItem);
Vue.use(Select);
Vue.use(Option);
Vue.use(OptionGroup);
Vue.use(DatePicker);
Vue.use(Switch);
Vue.use(Col);
Vue.use(Upload);
Vue.use(TableColumn);
Vue.use(ButtonGroup);
Vue.use(MenuItem);
Vue.use(MenuItemGroup);
Vue.use(Tag);
Vue.use(Input);
Vue.use(InputNumber);
Vue.use(Checkbox);
Vue.use(CheckboxButton);
Vue.use(CheckboxGroup);
Vue.use(Radio);
Vue.use(RadioGroup);
Vue.use(RadioButton);
Vue.prototype.$loading = Loading.service;
Vue.prototype.$message = Message;
Vue.prototype.$showLoading = showLoading;
Vue.prototype.$hideLoading = hideLoading;
Vue.prototype.$msgbox = MessageBox;
Vue.prototype.$alert = MessageBox.alert;
Vue.prototype.$confirm = MessageBox.confirm;
Vue.prototype.$prompt = MessageBox.prompt;
Vue.config.productionTip = false;

Vue.filter('upperCase', str => {
  return str.toString().toUpperCase()
});

Vue.filter('capCase', str => {
  return str.slice(0, 1).toUpperCase() + str.slice(1);
});

Vue.filter('roundNum', (float, digit) => {
  return (float ? float : 0).toFixed(digit)
});

Vue.filter('sortArr', (arr, index) => {
  return [...arr].splice(index, arr.length).concat([...arr].splice(0, index))
});


new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');
